module.exports = __webpack_public_path__ + "static/media/react-icon.c5d5f39b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-icon.webp
// module id = 247
// module chunks = 1